var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 48,
    viewBox: "0 0 56 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410086640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005428"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624324",
    y: 3,
    width: 56,
    height: 42,
    rx: 6,
    fill: "#CEE7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624325",
    y: 11,
    width: 56,
    height: 17,
    fill: "#3269F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "xxxx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.832 20.016L11.016 16H13.496L15.048 18.336H15.144L16.6 16H19.16L16.296 20.016L19.16 24.16H16.68L15.112 21.776H15.016L13.48 24.16H11L13.832 20.016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4101 20.016L19.5941 16H22.0741L23.6261 18.336H23.7221L25.1781 16H27.7381L24.8741 20.016L27.7381 24.16H25.2581L23.6901 21.776H23.5941L22.0581 24.16H19.5781L22.4101 20.016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9883 20.016L28.1723 16H30.6523L32.2043 18.336H32.3003L33.7563 16H36.3162L33.4522 20.016L36.3162 24.16H33.8363L32.2682 21.776H32.1723L30.6362 24.16H28.1562L30.9883 20.016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5664 20.016L36.7504 16H39.2304L40.7824 18.336H40.8784L42.3344 16H44.8944L42.0304 20.016L44.8944 24.16H42.4144L40.8464 21.776H40.7504L39.2144 24.16H36.7344L39.5664 20.016Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsnIcon);
export default __webpack_public_path__ + "static/media/ssn-icon.77cd8c4bc1a4dc7ba83cabd1ed977846.svg";
export { ForwardRef as ReactComponent };